import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose, bindActionCreators } from "redux";
import ExpertHorizontalWideCard from "../../components/followManagement/ExpertHorizontalWideCard";
import SeriesHorizontalWideCard from "../../components/followManagement/SeriesHorizontalWideCard";
import CompanyHorizontalWideCard from "../../components/followManagement/CompanyHorizontalWideCard";
import TopicHorizontalWideCard from "../../components/followManagement/TopicHorizontalWideCard";
import FollowRecommendationList from "../../components/followManagement/FollowRecommendationList";
import FollowRecommendationGrid from "../../components/followManagement/FollowRecommendationGrid";
import { SiteConstants } from "../../constants/constant";
import cosmeticConfig from "../../../config/cosmeticConfig";
import {
  getFollowedObjects,
  followButtonClicked,
  unFollowButtonClicked,
  IsEmpty,
  getRecoObjects,
  fetchSearchResult
} from "../../util/commonFunctions";
import {
  hideLoader,
  showLoader
} from "../../actions";
import "../../followManagement.css";
import { throttle, debounce } from "throttle-debounce";
import HelmetComponent from "../../components/shared/Helmet";

class FollowManagementPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      topics: [],
      experts: [],
      series: [],
      recoCompanies: [],
      recoTopics: [],
      recoExperts: [],
      recoSeries: [],
      currentTab: "company",
      searchActive: false,
      searchTerm: "",
      searchResults: []
    };
    this.autocompleteSearchDebounced = debounce(SiteConstants.doneTypingInterval, this.autocompleteSearch);
    this.autocompleteSearchThrottled = throttle(SiteConstants.doneTypingInterval, this.autocompleteSearch);
    this.companyInput = React.createRef();
  }

  componentDidMount() {
    if (localStorage.getItem("token")) {
      this.fetchFollowedObjects('all', this.props.currentLanguage);
      this.fetchRecommendedObjects('all', this.props.currentLanguage);
    }
  }

  changeQuery = event => {
    this.setState({ searchTerm: event.target.value }, () => {
      const searchTerm = this.state.searchTerm;
      if (searchTerm.length > 2) {
        if (searchTerm.length < 5) {
          this.autocompleteSearchThrottled(this.state.searchTerm);
        } else {
          this.autocompleteSearchDebounced(this.state.searchTerm);
        }
      } else {
        this.setState({
          searchResults: []
        });
      }
    });
  };

  autocompleteSearch = searchTerm => {
    this._fetch(searchTerm);
  };

  _fetch = searchTerm => {
    if (this.state.currentTab == "company") {
      fetchSearchResult(this.fetchSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchTerm, 'company');
    } else if (this.state.currentTab == "expert") {
      fetchSearchResult(this.fetchSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchTerm, 'expert');
    } else if (this.state.currentTab == "series") {
      fetchSearchResult(this.fetchSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchTerm, 'series');
    } else {
      fetchSearchResult(this.fetchSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchTerm, 'topic');
    }
  };

  fetchSearchResultHandler = (response, error) => {
    this.setState({
      searchResults: response
    });
  }

  getFollowedCompaniesStatusRespHandler = (response, error) => {
    this.setState({
      companies: response
    });
  }

  getFollowedExpertsStatusRespHandler = (response, error) => {
    console.log("Followed experts", response)
    this.setState({
      experts: response
    });
  }

  getFollowedSeriesStatusRespHandler = (response, error) => {
    this.setState({
      series: response
    });
  }

  getFollowedTopicsStatusRespHandler = (response, error) => {
    this.setState({
      topics: response
    });
  }

  getRecoExpertsRespHandler = (response, error) => {
    this.setState({
      recoExperts: response
    });
  }

  getRecoCompaniesRespHandler = (response, error) => {
    this.setState({
      recoCompanies: response
    });
  }

  getRecoTopicsRespHandler = (response, error) => {
    this.setState({
      recoTopics: response
    });
  }

  getRecoSeriesRespHandler = (response, error) => {
    this.setState({
      recoSeries: response
    });
  }

  updateCurrentTab = (newTab) => {
    this.setState({
      currentTab: newTab
    });
    this.updateSearchStatus(false);
  }

  updateSearchStatus = (newState) => {
    this.setState({
      searchActive: newState
    });
    if (!newState) {
      this.clearSearchTerm();
    }
    if (newState) {
      setTimeout(() => {
        this.companyInput.current.focus();
      }, 200);
    }
  }

  clearSearchTerm = () => {
    this.setState({
      searchTerm: '',
      searchResults: []
    });
  }

  followObject = (objectId, objectType) => {
    console.log("Local storage token", localStorage.getItem("token"));
    console.log("Follow Object ID:", objectId);
    console.log("Follow Object type:", objectType);
    if (localStorage.getItem("token")) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      } else if (objectType == "topic") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
      } else if (objectType == "series") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
      }
    }
  }

  unFollowObject = (objectId, objectType) => {
    if (objectType == "company") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
    } else if (objectType == "expert") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    } else if (objectType == "topic") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
    } else if (objectType == "series") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
    }
  }

  followButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
    this.fetchFollowedObjects(response.objectType, this.props.currentLanguage);
  }

  unFollowButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  updateFollowBtnStatus = (objectId, objectType) => {
    console.log("Update follow button status", objectId, objectType)
    if (objectType == "company") {
      this.followStatusUpdaterFn('companies', objectId);
      this.followStatusUpdaterFn('recoCompanies', objectId);
    }
    if (objectType == "expert") {
      this.followStatusUpdaterFn('experts', objectId);
      this.followStatusUpdaterFn('recoExperts', objectId);
    }
    if (objectType == "topic") {
      this.followStatusUpdaterFn('topics', objectId);
      this.followStatusUpdaterFn('recoTopics', objectId);
    }
    if (objectType == "series") {
      this.followStatusUpdaterFn('series', objectId);
      this.followStatusUpdaterFn('recoSeries', objectId);
    }
    if (this.state.searchResults.length > 0) {
      this.followStatusUpdaterFn('searchResults', objectId);
    }
  }

  fetchFollowedObjects = (objectType, currentLanguage) => {
    console.log("Fetching followed objects:", objectType, currentLanguage);
    if (objectType == "company") {
      getFollowedObjects(this.getFollowedCompaniesStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], true);
    } else if (objectType == "expert") {
      getFollowedObjects(this.getFollowedExpertsStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, false, true);
    } else if (objectType == "topic") {
      getFollowedObjects(this.getFollowedTopicsStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, true);
    } else if (objectType == "series") {
      getFollowedObjects(this.getFollowedSeriesStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, false, false, true);
    } else {
      getFollowedObjects(this.getFollowedCompaniesStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], true);
      getFollowedObjects(this.getFollowedTopicsStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, true);
      getFollowedObjects(this.getFollowedExpertsStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, false, true);
      getFollowedObjects(this.getFollowedSeriesStatusRespHandler, currentLanguage, localStorage.getItem("token"), [], false, false, false, true);
    }
  }

  fetchRecommendedObjects = (objectType, currentLanguage) => {
    console.log("Fetching recommended objects:", objectType, currentLanguage);

    if (objectType == "company") {
      getRecoObjects(this.getRecoCompaniesRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_COMPANY, true);
    } else if (objectType == "expert") {
      getRecoObjects(this.getRecoExpertsRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_EXPERT, false, false, true);
    } else if (objectType == "topic") {
      getRecoObjects(this.getRecoTopicsRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_TOPIC, false, true);
    } else if (objectType == "series") {
      getRecoObjects(this.getRecoSeriesRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_SERIES, false, false, false, true);
    } else {
      getRecoObjects(this.getRecoExpertsRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_EXPERT, false, false, true);
      getRecoObjects(this.getRecoCompaniesRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_COMPANY, true);
      getRecoObjects(this.getRecoTopicsRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_TOPIC, false, true);
      getRecoObjects(this.getRecoSeriesRespHandler, currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_watchlist.MAX_SERIES, false, false, false, true);
    }
  }

  followStatusUpdaterFn = (stateVar, objectId) => {
    let updated_objects = [];
    Object.values(this.state[stateVar]).map(values => {
      if (values?.id == objectId) {
        values.isFollowing = !values.isFollowing;
      }
      updated_objects.push(values);
    });
    this.setState({
      [stateVar]: updated_objects
    });
  }

  handleGlobalClick = (e) => {
    if (!e.target.classList.contains('keepSearchEnabled') && this.state.searchActive) {
      this.updateSearchStatus(false);
    }
  }


  render() {
    return (
      <React.Fragment>
        <HelmetComponent
          title="Watchlist | ausbiz"
          noIndex="true"
        />
        <div className="contentWhite" onClick={((e) => this.handleGlobalClick(e))}>
          <div className="follow-mgmnt-header">
            <div className="container">
              <div className="follow-header-block">
                <h1>Watchlist</h1>
                <p>Add companies, experts and topics to your Watchlist to personalise your ‘For You’ feed.</p>
              </div>
              <div className="follow-mgmnt-tabs">
                <ul>
                  <li data-id="companies-tab" className={this.state.currentTab == "company" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("company")} >Companies</li>
                  <li data-id="experts-tab" className={this.state.currentTab == "expert" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("expert")} >Experts</li>
                  <li data-id="topics-tab" className={this.state.currentTab == "topic" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("topic")} >Topics</li>
                  <li data-id="series-tab" className={this.state.currentTab == "series" ? "follow-mgmnt-tab active" : "follow-mgmnt-tab"} onClick={() => this.updateCurrentTab("series")} >Series</li>
                </ul>
              </div>
            </div>
          </div>
          <div className={this.state.searchActive ? "mgmnt-tab-content overlay" : "mgmnt-tab-content"}>
            <div className="container">


              {this.state.currentTab == "company" && // company tab content
                <div id="companies-tab" className="mgmnt-tab-block show">
                  <div className="mgmt-search-block">
                    <div className="mgmt-add-btn">
                      <span className="keepSearchEnabled" onClick={() => this.updateSearchStatus(true)}>Add a Company</span>
                    </div>
                    <div className={this.state.searchActive ? "mgmt-search-fld active keepSearchEnabled" : "mgmt-search-fld keepSearchEnabled"}>
                      {this.state.searchTerm.length > 0 &&
                        <div className="search-close-block">
                          <span className="search-clear show-clear keepSearchEnabled" onClick={this.clearSearchTerm}>Clear</span>
                          <span className="search-cross show-cross"></span>
                        </div>
                      }
                      <input
                        type="text"
                        placeholder="Search by company name or ticker code"
                        value={this.state.searchTerm}
                        onChange={this.changeQuery}
                        ref={this.companyInput}
                        id="companySearchInput"
                        className="search-fld keepSearchEnabled"
                      />
                      <div className={this.state.searchTerm.length > 2 ? "search-filter-block open-filter keepSearchEnabled" : "search-filter-block keepSearchEnabled"}>
                        <ul>
                          {this.state.searchResults.length == 0 &&
                            <li className="keepSearchEnabled no-results-found">
                              No results found
                            </li>
                          }
                          {this.state.searchResults.length > 0 && this.state.searchResults.map((item, index) => {
                            return (
                              <li className="keepSearchEnabled" key={`companiesSearch${index}`} onClick={() => { !item.isFollowing ? this.followObject(item.id, "company") : '' }}
                              >
                                <div className="comp-info keepSearchEnabled">
                                  <div className="comp-img keepSearchEnabled">
                                    <img className="keepSearchEnabled" src={item.url} style={{ maxWidth: "100%" }} />
                                  </div>
                                  <div className="comp-title keepSearchEnabled">

                                    <h4 className="keepSearchEnabled">
                                      {item.name}
                                      {item && item.industry && item.industry.name &&
                                        <span className="keepSearchEnabled">
                                          {item.industry.name}
                                        </span>
                                      }
                                    </h4>
                                  </div>
                                </div>
                                <div className="search-follow-btns keepSearchEnabled">
                                  <span className={!item.isFollowing ? "search-follow-btn keepSearchEnabled" : "search-follow-btn hide"} >Follow</span>
                                  <span className={item.isFollowing ? "search-unfollow-btn keepSearchEnabled" : "search-unfollow-btn hide"}>Following</span>
                                </div>
                              </li>
                            );
                          })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="list-wrapper-block">
                    <CompanyHorizontalWideCard
                      companies={this.state.companies}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                    <FollowRecommendationList
                      object="company"
                      headingText="Companies to follow"
                      recoObjects={this.state.recoCompanies}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                  </div>
                </div>
              }


              {this.state.currentTab == "expert" && // expert tab content
                <div id="experts-tab" className="mgmnt-tab-block show"  >
                  <div className="mgmt-search-block">
                    <div className="mgmt-add-btn">
                      <span className="keepSearchEnabled" onClick={() => this.updateSearchStatus(true)} >Add an Expert</span>
                    </div>
                    <div className={this.state.searchActive ? "mgmt-search-fld active keepSearchEnabled" : "mgmt-search-fld keepSearchEnabled"}>
                      {this.state.searchTerm.length > 0 &&
                        <div className="search-close-block">
                          <span className="search-clear show-clear keepSearchEnabled" onClick={this.clearSearchTerm}>Clear</span>
                          <span className="search-cross show-cross"></span>
                        </div>
                      }
                      <input
                        type="text"
                        placeholder="Search by expert name"
                        value={this.state.searchTerm}
                        onChange={this.changeQuery}
                        ref={this.companyInput}
                        className="search-fld keepSearchEnabled"
                      />
                      <div className={this.state.searchTerm.length > 2 ? "search-filter-block open-filter keepSearchEnabled" : "search-filter-block keepSearchEnabled"}>
                        <ul>
                          {this.state.searchResults.length == 0 &&
                            <li className="keepSearchEnabled no-results-found">
                              No results found
                            </li>
                          }
                          {this.state.searchResults.length > 0 && this.state.searchResults.map((item, index) => {
                            return (
                              <li className="keepSearchEnabled" key={`expertSearch${index}`} onClick={() => { !item.isFollowing ? this.followObject(item.id, "expert") : '' }}>
                                <div className="comp-info keepSearchEnabled">
                                  <div className="comp-img expert-circle keepSearchEnabled">
                                    <img className="keepSearchEnabled" src={item.url} style={{ maxWidth: "100%" }} />
                                  </div>
                                  <div className="comp-title keepSearchEnabled">
                                    <h4 className="keepSearchEnabled">
                                      {item.name}
                                      <span className="keepSearchEnabled">
                                        {item.role} | {item.company}
                                      </span>
                                    </h4>
                                  </div>
                                </div>
                                <div className="search-follow-btns keepSearchEnabled">
                                  <span className={!item.isFollowing ? "search-follow-btn keepSearchEnabled" : "search-follow-btn hide"} >Follow</span>
                                  <span className={item.isFollowing ? "search-unfollow-btn keepSearchEnabled" : "search-unfollow-btn hide"}>Following</span>
                                </div>
                              </li>
                            );
                          })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="list-wrapper-block">
                    <ExpertHorizontalWideCard
                      experts={this.state.experts}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                    <FollowRecommendationList
                      object="expert"
                      headingText="Who to follow"
                      recoObjects={this.state.recoExperts}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                  </div>
                </div>
              }


              {this.state.currentTab == "topic" && // topic tab content
                <div id="topics-tab" className="mgmnt-tab-block show" >
                  <div className="mgmt-search-block">
                    <div className="mgmt-add-btn">
                      <span className="keepSearchEnabled" onClick={() => this.updateSearchStatus(true)}>Add a Topic</span>
                    </div>
                    <div className={this.state.searchActive ? "mgmt-search-fld active keepSearchEnabled" : "mgmt-search-fld keepSearchEnabled"}>
                      {this.state.searchTerm.length > 0 &&
                        <div className="search-close-block">
                          <span className="search-clear show-clear keepSearchEnabled" onClick={this.clearSearchTerm}>Clear</span>
                          <span className="search-cross show-cross"></span>
                        </div>
                      }
                      <input
                        type="text"
                        placeholder="Search for a topic"
                        value={this.state.searchTerm}
                        onChange={this.changeQuery}
                        ref={this.companyInput}
                        className="search-fld keepSearchEnabled"
                      />
                      <div className={this.state.searchTerm.length > 2 ? "search-filter-block open-filter keepSearchEnabled" : "search-filter-block keepSearchEnabled"}>
                        <ul>
                          {this.state.searchResults.length == 0 &&
                            <li className="keepSearchEnabled no-results-found">
                              No results found
                            </li>
                          }
                          {this.state.searchResults.length > 0 && this.state.searchResults.map((item, index) => {
                            return (
                              <li className="keepSearchEnabled" key={`topicSearch${index}`} onClick={() => { !item.isFollowing ? this.followObject(item.id, "topic") : '' }}>
                                <div className="comp-info keepSearchEnabled">
                                  <div className="comp-title keepSearchEnabled">
                                    <h4 className="keepSearchEnabled">
                                      {item.name}
                                    </h4>
                                  </div>
                                </div>
                                <div className="search-follow-btns keepSearchEnabled">
                                  <span className={!item.isFollowing ? "search-follow-btn keepSearchEnabled" : "search-follow-btn hide"} >Follow</span>
                                  <span className={item.isFollowing ? "search-unfollow-btn keepSearchEnabled" : "search-unfollow-btn hide"}>Following</span>
                                </div>
                              </li>
                            );
                          })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="list-wrapper-block">
                    <TopicHorizontalWideCard
                      topics={this.state.topics}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                      currentLanguage={this.props.currentLanguage}
                    />
                    <FollowRecommendationGrid
                      object="topic"
                      headingText="Topics to follow"
                      recoObjects={this.state.recoTopics}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                      currentLanguage={this.props.currentLanguage}

                    />
                  </div>
                </div>
              }

              {this.state.currentTab == "series" && // series tab content
                <div id="experts-tab" className="mgmnt-tab-block show"  >
                  <div className="mgmt-search-block">
                    <div className="mgmt-add-btn">
                      <span className="keepSearchEnabled" onClick={() => this.updateSearchStatus(true)} >Add a Series</span>
                    </div>
                    <div className={this.state.searchActive ? "mgmt-search-fld active keepSearchEnabled" : "mgmt-search-fld keepSearchEnabled"}>
                      {this.state.searchTerm.length > 0 &&
                        <div className="search-close-block">
                          <span className="search-clear show-clear keepSearchEnabled" onClick={this.clearSearchTerm}>Clear</span>
                          <span className="search-cross show-cross"></span>
                        </div>
                      }
                      <input
                        type="text"
                        placeholder="Search by series name"
                        value={this.state.searchTerm}
                        onChange={this.changeQuery}
                        ref={this.companyInput}
                        className="search-fld keepSearchEnabled"
                      />
                      <div className={this.state.searchTerm.length > 2 ? "search-filter-block open-filter keepSearchEnabled" : "search-filter-block keepSearchEnabled"}>
                        <ul>
                          {this.state.searchResults.length == 0 &&
                            <li className="keepSearchEnabled no-results-found">
                              No results found
                            </li>
                          }
                          {this.state.searchResults.length > 0 && this.state.searchResults.map((item, index) => {
                            return (
                              <li className="keepSearchEnabled" key={`seriesSearch${index}`} onClick={() => { !item.isFollowing ? this.followObject(item.id, "series") : '' }}>
                                <div className="comp-info keepSearchEnabled">
                                  <div className="comp-img keepSearchEnabled">
                                    {!IsEmpty(item.url) &&
                                      <img className="keepSearchEnabled" src={item.url} style={{ maxWidth: "100%" }} />
                                    }
                                    {IsEmpty(item.url) &&
                                      <img src="/assets/ausbiz_series_logo.png" style={{ maxWidth: "100%" }} />
                                    }
                                  </div>
                                  <div className="comp-title keepSearchEnabled">
                                    <h4 className="keepSearchEnabled">
                                      {item.name}
                                    </h4>
                                  </div>
                                </div>
                                <div className="search-follow-btns keepSearchEnabled">
                                  <span className={!item.isFollowing ? "search-follow-btn keepSearchEnabled" : "search-follow-btn hide"} >Follow</span>
                                  <span className={item.isFollowing ? "search-unfollow-btn keepSearchEnabled" : "search-unfollow-btn hide"}>Following</span>
                                </div>
                              </li>
                            );
                          })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="list-wrapper-block">
                    <SeriesHorizontalWideCard
                      series={this.state.series}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                    <FollowRecommendationList
                      object="series"
                      headingText="Series to follow"
                      recoObjects={this.state.recoSeries}
                      followObject={this.followObject}
                      unFollowObject={this.unFollowObject}
                      parentProps={this.props}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.language.currentLanguage
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showLoader,
      hideLoader
    },
    dispatch
  );
}

export default {
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(FollowManagementPage)
};
